import { Contactos } from "./contactos";
import { Copyright } from "./copyright";

export function Footer() {
  return (
    <div
      className="container-fluid p-2 sticky-bottom"
      style={{ backgroundColor: "#0087CD" }}
    >
      <footer className="container d-sm-grid justify-content-sm-center d-md-flex justify-content-md-between align-items-center gap-2 text-white ">
        <Contactos />

        <Copyright />
      </footer>
    </div>
  );
}
